import { Council } from '../models/Council';
import { PagingParams, PagedResults } from '@abaco/web-common/src/Paging';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PlotGeom } from '@abaco/portal-global-state/src/modules/global-state/models/Plot';
export default class CouncilApi {

    private http: HTTPClient;

    constructor(http: HTTPClient){
        this.http = http;
    }

    async getCouncils(filter: string | null, paging: PagingParams): Promise<PagedResults<Council>> {
        const filters = ["fg_active eq 1"];
        if(filter) {
            filters.push(`^council_label like ${filter.toUpperCase()}`)
        }
        const res = await this.http.get("/sitiagri-rest-api/api_basic/v1/plots/dictionary_councils", {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filters,
            }
        });

        return res.data;
    }

    async getCouncilMbr(councilId: number): Promise<PlotGeom> {
        const res = await this.http.get("/sitiagri-rest-api/api_basic/v1/plots/dictionary_councils", {
            params: {
                offset: 0,
                count: 1,
                filter: `council_id eq ${councilId}`,
                get_mbr: true
            }
        });

        return res.data.records[0].mbr;
    }
}
